<template>
  <div class="item-filter-price">
    <div
      class="filter-container pb-3 d-flex flex-wrap showContent"
      v-if="priceSuggestionData"
    >
      <button
        v-if="
          typeof priceSuggestionData.valFirstMin === 'number' &&
          priceSuggestionData.valFirstMax
        "
        @click="
          updatePrice(
            priceSuggestionData.valFirstMin,
            priceSuggestionData.valFirstMax
          )
        "
        :class="{
          'filter-active':
            priceMin !== '' &&
            priceMin >= priceSuggestionData.valFirstMin &&
            priceMax <= priceSuggestionData.valFirstMax,
        }"
        class="list-item d-flex align-items-center"
      >
        {{ priceSuggestionData.valFirstMin | currency }}
        -
        {{ priceSuggestionData.valFirstMax | currency }}
      </button>
      <button
        v-if="
          priceSuggestionData.valSecondMin && priceSuggestionData.valSecondMax
        "
        @click="
          updatePrice(
            priceSuggestionData.valSecondMin,
            priceSuggestionData.valSecondMax
          )
        "
        :class="{
          'filter-active':
            priceMin >= priceSuggestionData.valSecondMin &&
            priceMax <= priceSuggestionData.valSecondMax,
        }"
        class="list-item d-flex align-items-center"
      >
        {{ priceSuggestionData.valSecondMin | currency }}
        -
        {{ priceSuggestionData.valSecondMax | currency }}
      </button>
      <button
        v-if="
          priceSuggestionData.valThirdMin && priceSuggestionData.valThirdMax
        "
        @click="
          updatePrice(
            priceSuggestionData.valThirdMin,
            priceSuggestionData.valThirdMax
          )
        "
        :class="{
          'filter-active':
            priceMin >= priceSuggestionData.valThirdMin &&
            priceMax <= priceSuggestionData.valThirdMax,
        }"
        class="list-item d-flex align-items-center"
      >
        {{ priceSuggestionData.valThirdMin | currency }}
        -
        {{ priceSuggestionData.valThirdMax | currency }}
      </button>
      <button
        v-if="
          priceSuggestionData.valFourthMin && priceSuggestionData.valFourthMax
        "
        @click="
          updatePrice(
            priceSuggestionData.valFourthMin,
            priceSuggestionData.valFourthMax
          )
        "
        :class="{
          'filter-active':
            priceMin >= priceSuggestionData.valFourthMin &&
            priceMax <= priceSuggestionData.valFourthMax,
        }"
        class="list-item d-flex align-items-center"
      >
        {{ priceSuggestionData.valFourthMin | currency }}
        -
        {{ priceSuggestionData.valFourthMax | currency }}
      </button>
    </div>

    <div class="d-flex align-items-center mb-3 facet-filter-price">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ currency }}</span>
        </div>

        <input
          type="number"
          class="form-control"
          @focus="selectAll($event)"
          placeholder="Min"
          v-model="priceMin"
          :aria-label="$translate('Ceres::Template.itemFilterPriceMin')"
        />
      </div>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">{{ currency }}</span>
        </div>

        <input
          type="number"
          class="form-control"
          @focus="selectAll($event)"
          placeholder="Max"
          v-model="priceMax"
          :aria-label="$translate('Ceres::Template.itemFilterPriceMax')"
        />
      </div>
    </div>

    <button
      type="button"
      class="btn btn-primary w-100"
      :class="{ disabled: isDisabled }"
      @click="triggerFilter()"
      :aria-label="$translate('Ceres::Template.itemFilterButton')"
    >
      {{ $translate("Ceres::Template.itemApply") }}
    </button>
  </div>
</template>

<script>
import UrlService from "../../../services/UrlService";
import { mapState } from "vuex";

export default {
  props: {
    categoryId: {
      type: Number,
    },
  },
  data() {
    return {
      priceSuggestionData: {},
      priceMin: "",
      priceMax: "",
      currency: App.activeCurrency,
    };
  },
  mounted() {
    const urlParams = UrlService.getUrlParams(document.location.search);

    this.priceMin = urlParams.priceMin || "";
    this.priceMax = urlParams.priceMax || "";

    this.getPriceSuggestion();
  },

  computed: {
    isDisabled() {
      return (
        (this.priceMin === "" && this.priceMax === "") ||
        parseInt(this.priceMin) >= parseInt(this.priceMax) ||
        this.isLoading
      );
    },

    ...mapState({
      isLoading: (state) => state.itemList.isLoading,
    }),
  },

  methods: {
    updatePrice(minPrice, maxPrice) {
      this.priceMin = minPrice;
      this.priceMax = maxPrice;
    },

    selectAll(event) {
      event.target.select();
    },
    async getPriceSuggestion() {
      if (this.$props.categoryId) {
        try {
          const response = await fetch(
            `https://morgenland-cpanel.eu/api/morgenland-category-range?catId=${this.$props.categoryId}&host=${window.location.host}`
          );
          const data = await response.json();
          this.priceSuggestionData = data.data.range;
        } catch (error) {
          console.error("Error fetching price suggestion:", error);
          this.priceSuggestionData = {};
        }
      }
    },
    triggerFilter() {
      if (!this.isDisabled) {
        this.$store.dispatch("selectPriceFacet", {
          priceMin: this.priceMin,
          priceMax: this.priceMax,
        });
      }
    },
  },

  watch: {
    priceMin(newValue) {
      if (newValue !== "" && parseInt(newValue) < 0) {
        this.priceMin = 0;
      }
    },
    priceMax(newValue) {
      if (newValue !== "" && parseInt(newValue) < 0) {
        this.priceMax = 0;
      }
    },
  },
};
</script>
